<script>
/**
 * FormGrid
 * ---------------------------------------------------------------------------
 * Contenedor de formulario responsive. Es un `.row` con gutters consistentes.
 * Se combina con <FormField> para reemplazar las grillas problemáticas de
 * `col-sm-3`/`col-sm-2`/`col-sm-1` (campos ultra-finos en tablet/móvil).
 *
 * No envuelve ni modifica los inputs: solo aporta el layout. El v-model y
 * la lógica siguen en los inputs del slot, intactos.
 *
 * Uso:
 *   <FormGrid>
 *     <FormField label="Nombre"><input v-model="x" class="form-control"/></FormField>
 *     <FormField label="NIT" :cols="{ md: 6, lg: 3 }"> ... </FormField>
 *   </FormGrid>
 */
export default {
  name: "FormGrid",
};
</script>

<template>
  <div class="row rwd-form-grid g-3">
    <slot />
  </div>
</template>

<style scoped>
.rwd-form-grid {
  /* gutters ya provistos por g-3; placeholder para futuros ajustes */
}
</style>
